import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "./components/Layout";
import CheckedIn from "./screens/CheckedIn";
import Home from "./screens/Home";
import { ContactUs } from "./screens/ContactUs";
import { NotFound } from "./screens/NotFound";
import { Profile } from "./screens/Profile";
import ReceiptScreen from "./screens/ReceiptScreen";
import SignInScreen from "./screens/SignIn";
import { SignOutPage } from "./screens/SignOut";
import ThankYouPage from "./screens/ThankYouPage";
import { Invite } from "./screens/Invite";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { Waiver } from "./components/Waiver";
import { Checkout } from "./screens/Checkout";
import { DataDeletion } from "./screens/DataDeletion";
import { EventDetail } from "./screens/EventDetail";
import { EventsList } from "./screens/EventsList";
import Landing from "./screens/Landing";
import { Share } from "./screens/Share";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "checkout", element: <Checkout /> },
      { path: "profile", element: <Profile /> },
      { path: "checked-in", element: <CheckedIn /> },
      { path: "thank-you", element: <ThankYouPage /> },
      { path: "privacy", element: <PrivacyPolicy /> },
      { path: "data-deletion", element: <DataDeletion /> },
      { path: "receipt/:orderId", element: <ReceiptScreen /> },
      { path: "terms", element: <Waiver /> },
      { path: "contact", element: <ContactUs /> },
      { path: "invite/:invitation", element: <Invite /> },
      { path: "events/:eventSlug", element: <EventDetail /> },
      { path: "events", element: <EventsList /> },
      { path: "share", element: <Share /> },
    ],
  },
  { path: "signout", element: <SignOutPage /> },
  { path: "signin", element: <SignInScreen /> },
  { path: "/landing", element: <Landing /> },
  { path: "*", element: <NotFound /> },
]);

if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}

export default function App() {
  return <RouterProvider router={router} />;
}
